import { jsonAxios } from 'components/axios';
import CustomButton from 'components/common/CustomButton';
import CustomInput from 'components/common/CustomInput';
import MyPageTemplate from 'components/template/MyPageTemplate';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const InquiryCreate = () => {
    const navigate = useNavigate();
    const [data, setData] = useState({
        title: '',
        content: '',
    })
    const [clear, setClear] = useState<boolean>(false);

    useEffect(() => {
        setClear(!!data.title && !!data.content)
    }, [data])

    const saveInquiry = () => {
        const reqData = {
            title: data.title,
            content: data.content
        }
        jsonAxios.post('inquiry', reqData).then(res => {
            console.log(res.data)
            if (res.data.code === 200) {
                toast.success('정상적으로 문의되었습니다.')
                navigate(-1)
            }
            else {
                toast.error('생성중 에러가 발생했습니다.')
            }
        })
    }
    return (
        <MyPageTemplate background='bg-[#F8F8FA]'>
            <div className='flex flex-col gap-4 pt-10 tablet:pt-4 h-full min-h-dvh'>
                <div className='flex flex-col gap-3 bg-white hover:shadow-lg p-10 mobile:p-6 tablet:px-4 rounded-xl w-full transition-all'>
                    <div>
                        <p className='mb-3 font-semibold mobile:text-base text-2xl'>
                            제목
                        </p>
                        <CustomInput
                            type='type'
                            placeholder='문의제목을 넣어주세요.'
                            fontSize='base'
                            value={data.title ?? ''}
                            onChange={(e) => {
                                setData(p => ({
                                    ...p,
                                    title: e.target.value
                                }))
                            }}
                        />
                    </div>
                    <div className='mb-40'>
                        <p className='mb-3 font-semibold mobile:text-base text-2xl'>
                            내용
                        </p>
                        <textarea
                            className={`w-full h-full rounded-lg p-6 text-base placeholder:text-[#9D9EB7] placeholder:font-normal bg-[#F8F8FA] hover:border-[#B3B3B3] border border-transparent resize-none`}
                            rows={6}
                            value={
                                !!data.content
                                    ? data.content
                                    : ''
                            }
                            placeholder="문의사항 내용을 작성해 주시기 바랍니다. (500자 내외)"
                            onChange={(e) => {
                                setData(p => ({
                                    ...p,
                                    content: e.target.value
                                }))
                            }}
                            maxLength={500}
                        >
                        </textarea>
                    </div>

                    <div className='flex justify-between items-center gap-4'>
                        <CustomButton
                            title='뒤로'
                            className='bg-primary'
                            onClick={() => {
                                navigate(-1)
                            }}
                        />
                        <CustomButton
                            title='저장'
                            disabled={!clear}
                            className='bg-primary'
                            onClick={saveInquiry}
                        />
                    </div>
                </div>
            </div>
        </MyPageTemplate>
    )
}

export default InquiryCreate